import { HttpContextToken } from '@angular/common/http';

export const SKIP_AUTH0 = new HttpContextToken<boolean>(() => false);
